import React, { useState } from 'react'
import Primaryinput from '../../../components/form/primaryinput'
import Primaryaltbtn from '../../../components/form/primaryaltbtn';
import Functions from './functions';
import { APP_VERSION, BUILD_TIME } from '../../../configTools/version';

const Form = () => {
    const [username,setUsername] = useState('');
    const [password,setPassword] = useState('');
  return (
    <div>
        <span style={{
            position:'fixed', bottom:'4px', right:'6px',
            fontSize:'9px', color:'#000', opacity:0.18,
            fontFamily:'monospace', letterSpacing:0, userSelect:'none', zIndex:9999
        }}>v{APP_VERSION} · {BUILD_TIME}</span>
        <div className='public_header_complete colorprimarybg'></div>
        <div className='public_login_wrapper'>
        <div className='public_login_container colorprimarybg'>
            <div className='public_login_form colorsecondarybg'>
                <h3>Login to continue</h3>
                <Primaryinput Lable={'Username'} Type={'text'} Value={username} setInput={setUsername} onkeyPress={(event)=>{
                    if(event.key === 'Enter'){
                        Functions.Submit({
                            username: username,
                            password: password
                        });
                    }
                }}/>
                <Primaryinput Lable={'Password'} Type={'password'} Value={password} setInput={setPassword} onkeyPress={(event)=>{
                    if(event.key === 'Enter'){
                        Functions.Submit({
                            username: username,
                            password: password
                        });
                    }
                }}/>
                <Primaryaltbtn Value={'Login'} Action={()=>{
                    Functions.Submit({
                        username: username,
                        password: password
                    });
                }}/>
            </div>
        </div>
        </div>
    </div>
  )
}

export default Form
